<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/Borrow'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <!--Begin : Collap ค้นหาเอกสารใบคำร้อง-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <Collapsible class="requestDoc-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาเอกสารใบคำร้อง
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-plus-square"></i> ค้นหาเอกสารใบคำร้อง
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="requestDoc">
                    <div class="row">
                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                        <div class="form-group">
                          <label>มุมมองผู้ใช้งาน:</label>
                          <treeselect id="reViewPermissionCode" 
                            v-model="reViewPermissionCode" 
                            :multiple="false" 
                            :options="reViewPermissionOptions"
                            :clear-on-select="true" 
                            placeholder="กรุณาเลือก" 
                            @input="ChangeOptions('View')" />
                        </div>
                      </div>
                      
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>เลขที่เอกสารใบคำร้องขอ:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwRequestDocNo'"
                            :name="'reBrwRequestDocNo'"
                            :select2-options="reBrwRequestDocNoOptions"
                            multiple
                            v-model="reBrwRequestDocNo"
                          ></select2> -->

                          <treeselect
                            v-model="reBrwRequestDocNo"
                            :multiple="true"
                            :load-options="LoadreBrwRequestDocNoOptions"
                            :async="true"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="false"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label">วันที่อนุมัติ(เริ่มต้น):</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reBrwLastApproveDateStart"
                              name="reBrwLastApproveDateStart"
                              ref="reBrwLastApproveDateStart"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label">วันที่อนุมัติ(สิ้นสุด):</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reBrwLastApproveDateEnd"
                              name="reBrwLastApproveDateEnd"
                              ref="reBrwLastApproveDateEnd"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>เดือน:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwLastApproveMonth'"
                            :name="'reBrwLastApproveMonth'"
                            :select2-options="reBrwLastApproveMonthOptions"
                            multiple
                            v-model="reBrwLastApproveMonth"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwLastApproveMonth"
                            :multiple="true"
                            :options="reBrwLastApproveMonthOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ปี:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwLastApproveYear'"
                            :name="'reBrwLastApproveYear'"
                            :select2-options="reBrwLastApproveYearOptions"
                            multiple
                            v-model="reBrwLastApproveYear"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwLastApproveYear"
                            :multiple="true"
                            :options="reBrwLastApproveYearOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ประเภทใบคำร้องขอ:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwRequestTypeCodes'"
                            :name="'reBrwRequestTypeCodes'"
                            :select2-options="reBrwRequestTypeCodesOptions"
                            multiple
                            v-model="reBrwRequestTypeCodes"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwRequestTypeCodes"
                            :multiple="true"
                            :options="reBrwRequestTypeCodesOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label> ผู้ขอเบิก/ยืม:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwBorrowerId'"
                            :name="'reBrwBorrowerId'"
                            :select2-options="reBrwBorrowerIdOptions"
                            multiple
                            v-model="reBrwBorrowerId"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwBorrowerId"
                            :multiple="true"
                            :options="reBrwBorrowerIdOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'AGENT_REPORT'"
                      >
                        <div class="form-group">
                          <label> ตัวแทนจำหน่าย/หน่วยงาน:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwBorrowerAgentOrg'"
                            :name="'reBrwBorrowerAgentOrg'"
                            :select2-options="reBrwBorrowerAgentOrgOptions"
                            multiple
                            v-model="reBrwBorrowerAgentOrg"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwBorrowerAgentOrg"
                            :multiple="true"
                            :options="reBrwBorrowerAgentOrgOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'AGENT_REPORT'"
                      >
                        <div class="form-group">
                          <label> ตัวแทนจำหน่าย:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwAgentCode'"
                            :name="'reBrwAgentCode'"
                            :select2-options="reBrwAgentCodeOptions"
                            multiple
                            v-model="reBrwAgentCode"
                          ></select2> -->
                          <!-- <treeselect
                            v-model="reBrwAgentCode"
                            :multiple="true"
                            :options="reBrwAgentCodeOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          /> -->
                          <treeselect
                            v-model="reBrwAgentCode"
                            :multiple="true"
                            :async="true"
                            :load-options="LoadreBrwAgentCodeOptions"
                            :defaultOptions="true"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'AGENT_REPORT'"
                      >
                        <div class="form-group">
                          <label> ร้านค้า:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwShopId'"
                            :name="'reBrwShopId'"
                            :select2-options="reBrwShopIdOptions"
                            multiple
                            v-model="reBrwShopId"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwShopId"
                            :multiple="true"
                            :load-options="LoadreBrwShopIdOptions"
                            :async="true"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="false"
                          />
                        </div>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-show="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                        <div class="form-group">
                          <label>ตัวแทนจำหน่ายย่อย:</label>
                          <treeselect
                            id="reShop"
                            v-model="reShop"
                            :async="true"
                            :multiple="true"
                            :load-options="LoadShopOptions"
                            v-on:open="reLoadShopOptions"
                            v-on:select="ClearAfterselect"
                            searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                            placeholder="กรุณาเลือก"
                            :cacheOptions="false"
                            ref="reShop"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label> ชื่องานกิจกรรม:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwActivityId'"
                            :name="'reBrwActivityId'"
                            :select2-options="reBrwActivityIdOptions"
                            multiple
                            v-model="reBrwActivityId"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwActivityId"
                            :multiple="true"
                            :options="reBrwActivityIdOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>หมายเหตุกิจกรรม:</label>
                          <input
                            v-model="reBrwActivityRemark"
                            type="text"
                            class="form-control"
                            placeholder="กรุณาระบุ หมายเหตุกิจกรรม กรณีมีหลาย หมายเหตุกิจกรรม เช่น 12345,54321"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาเอกสารใบคำร้อง-->

              <!--Begin : Collap ค้นหาข้อมูลส่ง-คืน-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <Collapsible class="return-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาข้อมูลส่ง-คืน
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la	la-plus-square"></i> ค้นหาข้อมูลส่ง-คืน
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="return">
                    <div class="row">
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>เลขที่เอกสารใบเบิกยืม:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwJobNumber'"
                            :name="'reBrwJobNumber'"
                            :select2-options="reBrwJobNumberOptions"
                            multiple
                            v-model="reBrwJobNumber"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwJobNumber"
                            :multiple="true"
                            :options="reBrwJobNumberOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันที่ส่งสินค้า(เริ่มต้น):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reBrwJobDateStart"
                              name="reBrwJobDateStart"
                              ref="reBrwJobDateStart"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label">วันที่ส่งสินค้า(สิ้นสุด):</label>
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reBrwJobDateEnd"
                              name="reBrwJobDateEnd"
                              ref="reBrwJobDateEnd"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันที่กำหนดคืนสินค้า(เริ่มต้น):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reBrwReturnDateStart"
                              name="reBrwReturnDateStart"
                              ref="reBrwReturnDateStart"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group ">
                          <label class="label"
                            >วันที่กำหนดคืนสินค้า(สิ้นสุด):</label
                          >
                          <div class="input-group date">
                            <input
                              readonly
                              type="text"
                              class="form-control"
                              placeholder="(วว/ดด/ปปปป)"
                              id="reBrwReturnDateEnd"
                              name="reBrwReturnDateEnd"
                              ref="reBrwReturnDateEnd"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <i class="la la-calendar-check-o"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>เกินกำหนดการคืน(เริ่มต้น):</label>
                          <input
                            v-model="reBrwOverDaysStart"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุจำนวนวันคงค้าง(เริ่มต้น)"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>เกินกำหนดการคืน(สิ้นสุด):</label>
                          <input
                            v-model="reBrwOverDaysEnd"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุจำนวนวันคงค้าง(สิ้นสุด)"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>คงค้าง(เริ่มต้น):</label>
                          <input
                            v-model="reBrwRemainingStart"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุจำนวนวันคงค้าง(เริ่มต้น)"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>คงค้าง(สิ้นสุด):</label>
                          <input
                            v-model="reBrwRemainingEnd"
                            type="number"
                            class="form-control"
                            placeholder="กรุณาระบุจำนวนวันคงค้าง(สิ้นสุด)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapsible>
              </div>
              <!--End : Collap ค้นหาข้อมูลส่ง-คืน-->

              <!--Begin : Collap ค้นหาสินค้า โควตา-->
              <div class="col-xl-12 col-lg-12 col-md-12 .col-sm-12 col-xs-12">
                <Collapsible class="return-collapsible">
                  <div slot="trigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la la-minus-square"></i> ค้นหาสินค้า โควตา
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div slot="closedTrigger">
                    <div class="customTrigger">
                      <div class="kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-primary">
                          <i class="la	la-plus-square"></i> ค้นหาสินค้า โควตา
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div id="return">
                    <div class="row">
                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>หมวดหมู่สินค้า:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwProductGroupId'"
                            :name="'reBrwProductGroupId'"
                            :select2-options="reBrwProductGroupIdOptions"
                            multiple
                            v-model="reBrwProductGroupId"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwProductGroupId"
                            :multiple="true"
                            :options="reBrwProductGroupIdOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>ประเภทสินค้า:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwProductTypeId'"
                            :name="'reBrwProductTypeId'"
                            :select2-options="reBrwProductTypeIdOptions"
                            multiple
                            v-model="reBrwProductTypeId"
                          ></select2> -->

                          <treeselect
                            v-model="reBrwProductTypeId"
                            :multiple="true"
                            :options="reBrwProductTypeIdOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>สินค้า:</label>
                          <!-- <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwProductCode'"
                            :name="'reBrwProductCode'"
                            :select2-options="reBrwProductCodeOptions"
                            multiple
                            v-model="reBrwProductCode"
                          ></select2> -->
                          <treeselect
                            v-model="reBrwProductCode"
                            :multiple="true"
                            :options="reBrwProductCodeOptions"
                            :clear-on-select="true"
                            placeholder="กรุณาเลือก"
                          />
                        </div>
                      </div>

                      <div
                        class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                      >
                        <div class="form-group">
                          <label>โควตา (แบรนด์):</label>
                          <select2
                            :css-style="'width: 100%;'"
                            :css-class="'form-control m-select2'"
                            :id="'reBrwQuotaId'"
                            :name="'reBrwQuotaId'"
                            :select2-options="reBrwQuotaIdOptions"
                            multiple
                            v-model="reBrwQuotaId"
                          ></select2>
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapsible>
              </div>
            </div>

            <div class="row mb-3">
              <div
                class="col-xl-6"
                v-if="
                  this.$root.canShow([
                    'AGENT_REPORT',
                    'SUB_AGENT_REPORT',
                    'BR_REPORT',
                  ])
                "
              >
                <button
                  class="btn btn-outline-primary"
                  @click="exportBarcodes"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
//import "vue-collapsible-component/lib/vue-collapsible.css";
import Collapsible from "../../Shared/Collapsible"; //"vue-collapsible-component";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reBrwRequestDocNo: [],
      reBrwLastApproveMonth: [],
      reBrwLastApproveYear: [],
      reBrwRequestTypeCodes: [],
      reBrwBorrowerId: [],
      reBrwBorrowerAgentOrg: [],
      reBrwAgentCode: [],
      reBrwShopId: [],
      reBrwActivityId: [],
      reBrwActivityRemark: null,
      reBrwJobNumber: [],
      reBrwJobDateStart: null,
      reBrwJobDateEnd: null,
      reBrwReturnDateStart: null,
      reBrwReturnDateEnd: null,
      reBrwOverDaysStart: null,
      reBrwOverDaysEnd: null,
      reBrwRemainingStart: null,
      reBrwRemainingEnd: null,
      reBrwProductTypeId: [],
      reBrwQuotaId: [],
      reBrwProductCode: [],
      reBCurrentLocationShop: [],
      reBrwProductGroupId: [],
      reBrwLastApproveDateStart: null,
      reBrwLastApproveDateEnd: null,
      reBrwLastApproveMonthOptions: [],
      // reBrwLastApproveMonthOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเดือน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ApproveMonthQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwLastApproveYearOptions: [],
      // reBrwLastApproveYearOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกปี",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2LastApproveYearQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwRequestTypeCodesOptions: [],
      // reBrwRequestTypeCodesOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกปี",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=PRODUCT_LOAN_REQUEST_TYPE",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwBorrowerIdOptions: [],
      // reBrwBorrowerIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกผู้ขอเบิก/ยืม",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2BorrowerQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwBorrowerAgentOrgOptions: [],
      // reBrwBorrowerAgentOrgOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย/หน่วยงาน",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2AgentOrgQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //     templateResult: function(data) {
      //       return data.text;
      //     },
      //     language: {
      //       noResults: function() {
      //         return "ไม่พบข้อมูลตัวแทนจำหน่าย/หน่วยงาน";
      //       },
      //     },
      //   },
      // },
      reBrwAgentCodeOptions: [],
      // reBrwAgentCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2AgentBorrow",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      //   templateResult: function(data) {
      //     return data.text;
      //   },
      //   language: {
      //     noResults: function() {
      //       return "ไม่พบข้อมูลตัวแทนจำหน่าย";
      //     },
      //   },
      // },
      reBrwShopIdOptions: [],
      // reBrwShopIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ShopBorrow",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwActivityIdOptions: [],
      // reBrwActivityIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกชื่องานกิจกรรม",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ActivityBorrow",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwJobNumberOptions: [],
      // reBrwJobNumberOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเลขที่เอกสารใบเบิกยืม",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2JobNumber",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBBarcodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกBarcode",
        allowClear: true,
        ajax: {
          url: "/Api/Barcode/Select2BarcodeAll",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reBrwRequestDocNoOptions: [],
      // reBrwRequestDocNoOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกเลขที่เอกสารใบคำร้องขอ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2RequestDocNoQuery",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwProductTypeIdOptions: [],
      // reBrwProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwQuotaIdOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกโควตา (แบรนด์)",
        ajax: {
          url: "/Api/Quota/Select2Quota",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reBrwProductCodeOptions: [],
      // reBrwProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBrwProductGroupIdOptions: [],
      // reBrwProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reShop: [],
      reShopOptions: [],
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;

      self.reBrwRequestDocNo = [];
      self.reBrwLastApproveMonth = [];
      self.reBrwLastApproveYear = [];
      self.reBrwRequestTypeCodes = [];
      self.reBrwBorrowerId = [];
      self.reBrwBorrowerAgentOrg = [];
      self.reBrwAgentCode = [];
      self.reBrwShopId = [];
      self.reBrwActivityId = [];
      (self.reBrwActivityRemark = null), (self.reBrwJobNumber = []);
      self.reBrwJobDateStart = null;
      self.reBrwJobDateEnd = null;
      self.reBrwReturnDateStart = null;
      self.reBrwReturnDateEnd = null;
      self.reBrwOverDaysStart = null;
      self.reBrwOverDaysEnd = null;
      self.reBrwRemainingStart = null;
      self.reBrwRemainingEnd = null;
      self.reBrwProductTypeId = [];
      self.reBrwQuotaId = [];
      self.reBrwProductCode = [];
      self.reBCurrentLocationShop = [];
      self.reBrwProductGroupId = [];
      self.reBrwLastApproveDateStart = null;
      self.reBrwLastApproveDateEnd = null;
      self.reShop = [];

      $("#reBrwRequestDocNo")
        .val("")
        .trigger("change");

      $("#reBrwLastApproveMonth")
        .val("")
        .trigger("change");

      $("#reBrwLastApproveYear")
        .val("")
        .trigger("change");

      $("#reBrwRequestTypeCodes")
        .val("")
        .trigger("change");

      $("#reBrwBorrowerId")
        .val("")
        .trigger("change");

      $("#reBrwBorrowerAgentOrg")
        .val("")
        .trigger("change");

      $("#reBrwAgentCode")
        .val("")
        .trigger("change");

      $("#reBrwShopId")
        .val("")
        .trigger("change");

      $("#reBrwActivityId")
        .val("")
        .trigger("change");

      $("#reBrwJobNumber")
        .val("")
        .trigger("change");

      $("#reBrwProductTypeId")
        .val("")
        .trigger("change");

      $("#reBrwQuotaId")
        .val("")
        .trigger("change");

      $("#reBrwProductCode")
        .val("")
        .trigger("change");

      $("#reBrwProductGroupId")
        .val("")
        .trigger("change");

      $("#reShop")
        .val("")
        .trigger("change");
    },
    formSubmit: function(e) {
      let self = this;

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    exportBarcodes: function(e) {
      e.preventDefault();
      let self = this;

      if (
        self.reBrwLastApproveDateStart !== null ||
        self.reBrwLastApproveDateEnd !== null
      ) {
        if (
          self.reBrwLastApproveDateStart === null &&
          self.reBrwLastApproveDateEnd !== null
        ) {
          Swal.fire("กรุณาระบุ", "วันที่อนุมัติ(เริ่มต้น)", "warning");
          return false;
        } else if (
          self.reBrwLastApproveDateStart !== null &&
          self.reBrwLastApproveDateEnd === null
        ) {
          Swal.fire("กรุณาระบุ", "วันที่อนุมัติ(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (self.reBrwJobDateStart !== null || self.reBrwJobDateEnd !== null) {
        if (self.reBrwJobDateStart === null && self.reBrwJobDateEnd !== null) {
          Swal.fire("กรุณาระบุ", "วันที่ส่งสินค้า(เริ่มต้น)", "warning");
          return false;
        } else if (
          self.reBrwJobDateStart !== null &&
          self.reBrwJobDateEnd === null
        ) {
          Swal.fire("กรุณาระบุ", "วันที่ส่งสินค้า(สิ้นสุด)", "warning");
          return false;
        }
      }

      if (
        self.reBrwReturnDateStart !== null ||
        self.reBrwReturnDateEnd !== null
      ) {
        if (
          self.reBrwReturnDateStart === null &&
          self.reBrwReturnDateEnd !== null
        ) {
          Swal.fire("กรุณาระบุ", "วันที่กำหนดคืนสินค้า(เริ่มต้น)", "warning");
          return false;
        } else if (
          self.reBrwReturnDateStart !== null &&
          self.reBrwReturnDateEnd === null
        ) {
          Swal.fire("กรุณาระบุ", "วันที่กำหนดคืนสินค้า(สิ้นสุด)", "warning");
          return false;
        }
      }

      if(self.reBrwOverDaysStart == ""){
        self.reBrwOverDaysStart = null;
      }
      if(self.reBrwOverDaysEnd == ""){
        self.reBrwOverDaysEnd = null;
      }
      if (self.reBrwOverDaysStart !== null || self.reBrwOverDaysEnd !== null) {
        if (
          self.reBrwOverDaysStart === null &&
          self.reBrwOverDaysEnd !== null
        ) {
          Swal.fire("กรุณาระบุ", "เกินกำหนดการคืน(เริ่มต้น)", "warning");
          return false;
        } else if (
          self.reBrwOverDaysStart !== null &&
          self.reBrwOverDaysEnd === null
        ) {
          Swal.fire("กรุณาระบุ", "เกินกำหนดการคืน(สิ้นสุด)", "warning");
          return false;
        }
      }

      if(self.reBrwRemainingStart == ""){
        self.reBrwRemainingStart = null;
      }
      if(self.reBrwRemainingEnd == ""){
        self.reBrwRemainingEnd = null;
      }
      if (
        self.reBrwRemainingStart !== null ||
        self.reBrwRemainingEnd !== null
      ) {
        if (
          self.reBrwRemainingStart === null &&
          self.reBrwRemainingEnd !== null
        ) {
          Swal.fire("กรุณาระบุ", "คงค้าง(เริ่มต้น)", "warning");
          return false;
        } else if (
          self.reBrwRemainingStart !== null &&
          self.reBrwRemainingEnd === null
        ) {
          Swal.fire("กรุณาระบุ", "คงค้าง(สิ้นสุด)", "warning");
          return false;
        }
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportBorrow",
        responseType: "arraybuffer",
        data: {
          RequestDocNo: self.reBrwRequestDocNo,
          LastApproveDateStart:
            self.reBrwLastApproveDateStart != null
              ? self.reBrwLastApproveDateStart.format("DD/MM/YYYY")
              : null,
          LastApproveDateEnd:
            self.reBrwLastApproveDateEnd != null
              ? self.reBrwLastApproveDateEnd.format("DD/MM/YYYY")
              : null,
          LastApproveMonth: self.reBrwLastApproveMonth,
          LastApproveYear: self.reBrwLastApproveYear,
          RequestTypeCodes: self.reBrwRequestTypeCodes,
          BorrowerId: self.reBrwBorrowerId,
          BorrowerAgentOrg: self.reBrwBorrowerAgentOrg,
          AgentCode: self.reBrwAgentCode,
          ShopId: self.reBrwShopId,
          ActivityId: self.reBrwActivityId,
          ActivityRemark: self.reBrwActivityRemark,
          JobNumber: self.reBrwJobNumber,
          JobDateStart:
            self.reBrwJobDateStart != null
              ? self.reBrwJobDateStart.format("DD/MM/YYYY")
              : null,
          JobDateEnd:
            self.reBrwJobDateEnd != null
              ? self.reBrwJobDateEnd.format("DD/MM/YYYY")
              : null,
          ReturnDateStart:
            self.reBrwReturnDateStart != null
              ? self.reBrwReturnDateStart.format("DD/MM/YYYY")
              : null,
          ReturnDateEnd:
            self.reBrwReturnDateEnd != null
              ? self.reBrwReturnDateEnd.format("DD/MM/YYYY")
              : null,
          OverDaysStart: self.reBrwOverDaysStart,
          OverDaysEnd: self.reBrwOverDaysEnd,
          RemainingStart: self.reBrwRemainingStart,
          RemainingEnd: self.reBrwRemainingEnd,
          ProductGroupId: self.reBrwProductGroupId,
          ProductTypeId: self.reBrwProductTypeId,
          ProductCode: self.reBrwProductCode,
          QuotaId: self.reBrwQuotaId,
          ViewPermissionCode: self.reViewPermissionCode,
          ShopCode: self.reShop,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];
            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);

              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreBrwLastApproveMonthOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2ApproveMonthQuery", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwLastApproveMonthOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBrwLastApproveYearOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2LastApproveYearQuery", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwLastApproveYearOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBrwRequestTypeCodesOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=PRODUCT_LOAN_REQUEST_TYPE", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwRequestTypeCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBrwBorrowerIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2BorrowerQuery", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwBorrowerIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBrwBorrowerAgentOrgOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2AgentOrgQuery", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwBorrowerAgentOrgOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    // LoadreBrwAgentCodeOptions: function(e) {
    //   var self = this;
    //   axios
    //     .get("/Api/Report/Select2AgentBorrow", {
    //       params: {
    //         page: 1,
    //         all: true,
    //       },
    //     })
    //     .then(function(response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         data.forEach((element) => {
    //           self.reBrwAgentCodeOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function(error) {});
    // },
    LoadreBrwAgentCodeOptions: _.debounce(function({action, searchQuery, callback}) {
      var self = this;
      if (action === ASYNC_SEARCH) {
        axios
        .get("/Api/Report/Select2AgentBorrow", {
          params: {
            page: 1,
            all: true,
            search: searchQuery
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBrwAgentCodeOptions = [];
            data.forEach((element) => {
              self.reBrwAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
            callback(null, self.reBrwAgentCodeOptions);
          }
        })
        .catch(function(error) {});
      }
    },700),
    LoadreBrwShopIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reBrwShopIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Report/Select2ShopBorrow", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reBrwShopIdOptions = [];
              data.forEach((element) => {
                self.reBrwShopIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reBrwShopIdOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadreBrwActivityIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2ActivityBorrow", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwActivityIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBrwJobNumberOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2JobNumber", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwJobNumberOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBrwRequestDocNoOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reBrwRequestDocNoOptions = [];
      axios
        .get("/Api/Report/Select2RequestDocNoQuery", {
          params: {
            page: 1,
            all: true,
            search: searchQuery,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reBrwRequestDocNoOptions = [];
            data.forEach((element) => {
              self.reBrwRequestDocNoOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
          callback(null, self.reBrwRequestDocNoOptions);
        })
        .catch(function(error) {});
    },
    LoadreBrwProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBrwProductCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBrwProductGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBrwProductGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    async LoadreViewJobRetrieveOptions() {
      var self = this;
      await axios
        .get("/Api/Report/Select2ViewJobRetrieve", {})
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reViewPermissionOptions.push({
                id: element.id,
                label: element.text,
              });

              if (element.data == "active") {
                self.reViewPermissionCode = element.id;
              }
            });
          }
        })
        .catch(function (error) { });
    },
    ChangeOptions(type) {
      console.log("ChangeOptions");
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formReset();
        }
      }
    },
    LoadShopOptions({ action, searchQuery, callback }) {
      var self = this;
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Report/Select2SubAgentBorrow", {
            page: 1,
            all: true,
            search: searchQuery
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reShopOptions = [];
              data.forEach((element) => {
                self.reShopOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }

            callback(null, self.reShopOptions);
          })
          .catch(function(error) {});
      }
    },
    reLoadShopOptions: function(){
      this.$refs.reShop.trigger.searchQuery = null
    },
  },
  async mounted() {
    let self = this;

    self.LoadreBrwLastApproveMonthOptions();
    self.LoadreBrwLastApproveYearOptions();
    self.LoadreBrwRequestTypeCodesOptions();
    self.LoadreBrwBorrowerIdOptions();
    self.LoadreBrwBorrowerAgentOrgOptions();
    // self.LoadreBrwAgentCodeOptions();
    self.LoadreBrwActivityIdOptions();
    self.LoadreBrwJobNumberOptions();
    self.LoadreBrwProductTypeIdOptions();
    self.LoadreBrwProductCodeOptions();
    self.LoadreBrwProductGroupIdOptions();
    await self.LoadreViewJobRetrieveOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reBrwLastApproveDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reBrwLastApproveDateStart)
      .datepicker(
        "update",
        !!self.reBrwLastApproveDateStart
          ? self.reBrwLastApproveDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBrwLastApproveDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBrwLastApproveDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reBrwLastApproveDateEnd)
      .datepicker(
        "update",
        !!self.reBrwLastApproveDateEnd
          ? self.reBrwLastApproveDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBrwLastApproveDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    //=====
    $(self.$refs.reBrwJobDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reBrwJobDateStart)
      .datepicker(
        "update",
        !!self.reBrwJobDateStart
          ? self.reBrwJobDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBrwJobDateStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBrwJobDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reBrwJobDateEnd)
      .datepicker(
        "update",
        !!self.reBrwJobDateEnd
          ? self.reBrwJobDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBrwJobDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBrwJobDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reBrwJobDateStart)
      .datepicker(
        "update",
        !!self.reBrwJobDateStart
          ? self.reBrwJobDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBrwJobDateStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBrwJobDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reBrwJobDateEnd)
      .datepicker(
        "update",
        !!self.reBrwJobDateEnd
          ? self.reBrwJobDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBrwJobDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBrwReturnDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reBrwReturnDateStart)
      .datepicker(
        "update",
        !!self.reBrwReturnDateStart
          ? self.reBrwReturnDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBrwReturnDateStart = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";

    $(self.$refs.reBrwReturnDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reApLastActivityDateEnd = moment().endOf('month');
    $(self.$refs.reBrwReturnDateEnd)
      .datepicker(
        "update",
        !!self.reBrwReturnDateEnd
          ? self.reBrwReturnDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBrwReturnDateEnd = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/Borrow.vue